<template>
  <div>
    <b-row>
      <b-col
        cols="9"
        class="mb-1"
      >
        <b-link
          style="font-size: 26px; color: #fff;"
          :to="`/lighting-sub?DeptID=${deptid}`"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /> <span style="color: #00FF80;"> ไฟฟ้าส่องสว่าง: </span> {{ waydetail }}
        </b-link>
      </b-col>
      <b-col
        cols="3"
        class="text-sm-right d-flex align-items-center justify-content-end"
      >
        <div class="mr-1">
          <b-link
            v-b-modal="'Log'"
            class="nav-link"
            variant="outline-primary"
            @click="$refs.Log.getTableNBIoTLog(items.imei)"
          >
            <feather-icon
              icon="FileTextIcon"
              size="24"
              style="color:aqua"
            />
            <span style="color:#ffffff"> Log</span>
          </b-link>
        </div>
        <div class="mr-1">
          <b-dropdown
            id="dropdown-right"
            right
            text="รายงาน"
            variant="primary"
            class="btn-icon"
          >
            <!-- รายงานการทำงานตู้ควบคุม -->
            <b-dropdown-item :href="`/reportsemcontrol1day-lora?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการทำงานตู้ควบคุมรายวัน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportsemcontrol1month-lora?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการทำงานตู้ควบคุมรายเดือน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportsemcontrol1year-lora?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการทำงานตู้ควบคุมรายปี
            </b-dropdown-item>
            <b-dropdown-divider />
            <!-- รายงานการซ่อมปุกรณ์ -->
            <b-dropdown-item :href="`/reportrepair1day-lora?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการซ่อมอุปกรณ์รายวัน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportrepair1month-lora?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการซ่อมอุปกรณ์รายเดือน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportrepair1year-lora?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการซ่อมอุปกรณ์รายปี
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card
          class="hero4"
          style="font-size:18px; width:auto; height:auto; background-color:rgba(0, 0, 0, 0.6); color:#ffffff; border: 1px solid #00B058; border-radius: 20px;"
        >
          <b-row>
            <b-col
              cols="8"
            >
              <h3>Single line Diagram</h3>
            </b-col>
            <b-col
              cols="4"
              class="d-flex align-items-center justify-content-end"
            >
              <label class="mr-1"> เปิด/ปิดตู้ไฟ </label>
              <toggle-button
                class="mr-1"
                :width="60"
                :height="25"
                :sync="true"
                :value="this.switch.drv1_cmd"
                :color="{checked: '#29CD21', unchecked: '#FF0000', disabled: '#29CD21'}"
                :labels="{checked: 'เปิด', unchecked: 'ปิด'}"
                @change="onChangeActive($event)"
              />
            </b-col>
            <b-col
              lg="12"
              md="12"
              sm="12"
            >
              <STW1_1MCB_1PW_1MC_2CB />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <modalLog
      ref="Log"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BCard, BDropdownDivider, BDropdownItem, BDropdown, BLink,
} from 'bootstrap-vue'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
import modalLog from './modalLog.vue'
import STW1_1MCB_1PW_1MC_2CB from './diagram/1STW-1MCB-1PW-1MC-2CB.vue'
/* eslint-disable global-require */

export default {
  components: {
    BCol,
    BRow,
    BCard,
    BDropdownDivider,
    BDropdownItem,
    BDropdown,
    BLink,
    modalLog,
    // eslint-disable-next-line vue/no-unused-components
    STW1_1MCB_1PW_1MC_2CB,
  },
  data() {
    return {
      waydetail: '',
      checkLeft1: '',
      checkRight1: '',
      checkLeft2: '',
      checkRight2: '',
      deptid: '',
      markers: [],
      items: [],
      switch: {
        semid: '',
        controller_id: 1,
        drv1_cmd: '',
      },
      sem_type: '',
      diagram_type: '',
    }
  },
  computed: {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getCenterSem()
    this.checkSwith()
    this.getValueDiagram()
    this.interval = setInterval(() => {
      this.getValueDiagram()
      this.getCenterSem()
      this.checkSwith()
    }, 10000)
  },
  mounted() {
  },
  methods: {
    onChangeActive(event) {
      this.$swal({
        title: '<span style="color:#000000">ต้องการปิดหรือเปิดตู้ไฟหรือไม่</span>',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.switch.drv1_cmd = event.value
          try {
            await axios.post('/swithSemControl', this.switch)
            if (event.value === true) {
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">เปิดเรียบร้อยแล้ว</span>',
                showConfirmButton: false,
                timer: 1000,
              })
            } else {
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">ปิดเรียบร้อยแล้ว</span>',
                showConfirmButton: false,
                timer: 1000,
              })
            }
            this.getValueDiagram()
            this.checkSwith()
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' กดเพื่อดำเนินการต่อ!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
    checkSwith() {
      axios
        .post('/checkSwithSemControl', { wid: this.$route.query.wid, controller_id: 1 })
        .then(response => {
          this.switch.semid = response.data[0].id
          if (response.data[0].drv1_cmd === 'CH1:CMD01:MT01=1;') {
            this.switch.drv1_cmd = true
          } else {
            this.switch.drv1_cmd = false
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCenterSem() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
          this.switch.semid = response.data[0].id
        })
        .catch(error => {
          console.log(error)
        })
    },
    getValueDiagram() {
      axios
        .post('/valueDiagram', { wid: this.$route.query.wid })
        .then(response => {
          this.sem_type = response.data[0].firmware
          this.diagram_type = response.data[0].diagram_type
          // eslint-disable-next-line prefer-destructuring
          this.items = response.data[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style  lang="scss" scoped>
.headline {
  font-size: 20px;
}
.title {
  color:#FFFFD5
}
.nowrap {
  white-space: nowrap ;
}

.hero4::before {
    content: "";
    background: url(~@/assets/images/icons/semcontrol/dark.jpg) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 0px;
    top : 0px;
    background-size: cover;
    width: 100%;
    height: 100%;
    opacity: 1.0;
    border-radius: 20px;
  }
</style>
